import { Component } from '@angular/core';

@Component({
  selector: 'app-counter-component',
  templateUrl: './counter.component.html'
})
export class CounterComponent {
  public currentCount = 0;
  public inputText = "";

  public incrementCounter() {
    this.currentCount++;
  }
  addInput() {
    this.currentCount = this.currentCount + 10;
    alert("this is a test- " + this.inputText);
  }

}
